module.exports = __webpack_public_path__ + "static/media/54 - New Paradise - I Love Video.353c9101.mp3";